import { IEvent } from "@quest/adapter-interface";
import { detectDeviceEnvironmentConstants, dispatcher, ingenuity } from "@quest/base-core";
import {
  BaseViewBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther";

export class CollectionScreenView extends BaseViewBehavior {
  constructor(view: any) {
    super(view);
  }

  public addViewToTop(): void {
    ingenuity.currentGame.stage.addChild(this);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }

  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.scale.set(ingenuity.deviceEnv.getPortraitMaxReelScale());
      this.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER;
      this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER + SlotConstantsBehavior.ADD_IN_Y;
    } else {
      this.pivot.set(ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
      this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale());
      this.x = (innerWidth * SlotConstantsBehavior.HALF_CONVERTER) + (SlotConstantsBehavior.REEL_SIDE_SPACE * this.scale.x);
      if (ingenuity.deviceEnv.isDesktop) {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((SlotConstantsBehavior.REEL_BOTTOM_SPACE / 2) * this.scale.x);
      }
      else {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((SlotConstantsBehavior.REEL_BOTTOM_SPACE_LANDSCAPE / 2) * this.scale.x);
      }
    }
  }
}
